<template>
  <div :class="[
    ns.b(),
    ns.is('contentful', !!$slots.default),
    {
      [ns.m('has-breadcrumb')]: !!$slots.breadcrumb,
      [ns.m('has-extra')]: !!$slots.extra,
    },
  ]">
    <div v-if="$slots.breadcrumb" :class="ns.e('breadcrumb')">
      <slot name="breadcrumb" />
    </div>
    <div :class="ns.e('header')">
      <div :class="ns.e('left')">
        <div :class="ns.e('back')" role="button" tabindex="0" @click="handleClick">
          <div v-if="icon || $slots.icon" :aria-label="title || t('z.pageHeader.title')" :class="ns.e('icon')">
            <slot name="icon">
              <z-icon v-if="icon">
                <component :is="icon" />
              </z-icon>
            </slot>
          </div>
          <div :class="ns.e('title')">
            <slot name="title">{{ title || t('z.pageHeader.title') }}</slot>
          </div>
        </div>
        <z-divider direction="vertical" />
        <div :class="ns.e('content')">
          <slot name="content">{{ content }}</slot>
        </div>
      </div>

      <div v-if="$slots.extra" :class="ns.e('extra')">
        <slot name="extra" />
      </div>
    </div>

    <div v-if="$slots.default" :class="ns.e('main')">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ZIcon } from '@zoryn/components/icon'
import { ZDivider } from '@zoryn/components/divider'
import { useLocale, useNamespace } from '@zoryn/hooks'
import { Back } from '@zoryn/icons'
import { pageHeaderEmits } from './page-header'

import type { PageHeaderProps } from './page-header'

defineOptions({
  name: 'ZPageHeader',
})

withDefaults(defineProps<PageHeaderProps>(), {
  icon: () => Back,
  content: '',
})
const emit = defineEmits(pageHeaderEmits)

const { t } = useLocale()
const ns = useNamespace('page-header')

function handleClick() {
  emit('back')
}
</script>
